require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./basic-styles-sandbox-eventbrite-test.json") })
        }
      }, "path---basic-styles-sandbox-eventbrite-test");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---basic-styles-sandbox-eventbrite-test!./.cache/json/basic-styles-sandbox-eventbrite-test.json
// module id = 1981
// module chunks = 231608221292675